import { Grid } from '@mui/material';
import { ReactElement, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import KPI from '../../component/kpi/KPI';
import { useMarketTerm } from '../../hooks/useMarketTerm';
import { getStatusKpis, itemEquipmentBreakdown, itemEquipmentBreakdownFetching } from '../../redux/slices/tools/toolsSlice';
import { useDispatch } from '../../redux/store';
import { itemsLink } from './itemsLink';

type StatusKpiRowProps = { manufacturerId?: string; productId?: string; category?: string };

// The tools dashboard's status tiles, reused wherever equipment is scoped to a
// manufacturer, a product or a category. One tile per scan status, each linking
// into the item list with the same scope plus that status.
export const StatusKpiRow = ({ manufacturerId, productId, category }: StatusKpiRowProps): ReactElement => {
  const dispatch = useDispatch();
  const kpisFor = useSelector(getStatusKpis);
  const term = useMarketTerm();
  const fetching = useSelector(itemEquipmentBreakdownFetching);

  useEffect(() => {
    dispatch(itemEquipmentBreakdown());
  }, [dispatch]);

  const kpis = useMemo(() => kpisFor({ manufacturerId, productId, category }), [kpisFor, manufacturerId, productId, category]);

  return (
    <Grid container spacing={4} sx={{ mb: 6 }}>
      {kpis.map((kpi) => (
        <Grid item xs={6} sm={4} md={2} key={kpi.label}>
          <KPI
            title={term(kpi.label)}
            data={[
              {
                amount: kpi.amount,
                color: kpi.amount ? 'blue' : 'black',
                link: itemsLink({ manufacturerId, productId, category, scanStatus: kpi.scanStatus }),
              },
            ]}
            fetching={fetching}
            dense
          />
        </Grid>
      ))}
    </Grid>
  );
};
